// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"167":"detail","443":"about","795":"goods","894":"services"}[chunkId] + "." + {"167":"0ae0fb24","443":"3db210e5","795":"cc84c511","894":"e6c3c41b"}[chunkId] + ".css";
};